// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.paginationButton {
  display: flex;
  justify-content: center;
}

.paginationButton button:nth-child(1) {
  padding: 0px 12px;
  height: 32px;
  border-radius: 2px;
  margin-right: 3px;
  border: none;
  color: white;
  background-color: var(--Primary_color);
  font-size: 14px;
}
.paginationButton button:nth-child(2) {
  padding: 0px 22px;
  height: 32px;
  border-radius: 2px;
  margin-right: 3px;
  border: 1px solid var(--Primary_color);
  color: var(--Primary_color);
  font-size: 14px;
  background-color: white;
}
.paginationButton > :nth-child(3) {
  padding: 0px 12px;
  height: 32px;
  border: none;
  border-radius: 2px;
  margin-right: 3px;
  font-size: 14px;
  color: #333;
  font-weight: 600;
  background-color: #bbf8c5;
  display: flex;
  align-items: center;
}
.paginationButton button:nth-child(4) {
  padding: 0px 12px;
  height: 32px;
  border: 1px solid var(--Primary_color);
  border-radius: 2px;
  margin-right: 3px;
  border: none;
  color: #fff;
  font-size: 14px;
  background-color: var(--Primary_color);
}

.paginationButton button:disabled {
  background-color: #93cfa3;
}

.backButton {
  background-color: transparent;
  border: none;
}
.backButton > img {
  width: 30px;
  height: 30px;
}

.paginationButton {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.page-input {
  width: 100px;
  padding: 5px;
  text-align: center;
}

.go-button {
  padding: 5px 10px;
  cursor: pointer;
}

.input-container {
  position: relative;
  display: inline-block;
}

.page-input {
  width: 100px;
  padding: 8px 28px 8px 10px; /* right padding for icon */
  box-sizing: border-box;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
}

.input-icon {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  color: #999;
  font-size: 14px;
  pointer-events: none;
  line-height: 1;
}

`, "",{"version":3,"sources":["webpack://./src/commanComponents/buttons/PaginationBtn.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,YAAY;EACZ,sCAAsC;EACtC,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,sCAAsC;EACtC,2BAA2B;EAC3B,eAAe;EACf,uBAAuB;AACzB;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,sCAAsC;EACtC,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,0BAA0B,EAAE,2BAA2B;EACvD,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,2BAA2B;EAC3B,WAAW;EACX,eAAe;EACf,oBAAoB;EACpB,cAAc;AAChB","sourcesContent":[".paginationButton {\n  display: flex;\n  justify-content: center;\n}\n\n.paginationButton button:nth-child(1) {\n  padding: 0px 12px;\n  height: 32px;\n  border-radius: 2px;\n  margin-right: 3px;\n  border: none;\n  color: white;\n  background-color: var(--Primary_color);\n  font-size: 14px;\n}\n.paginationButton button:nth-child(2) {\n  padding: 0px 22px;\n  height: 32px;\n  border-radius: 2px;\n  margin-right: 3px;\n  border: 1px solid var(--Primary_color);\n  color: var(--Primary_color);\n  font-size: 14px;\n  background-color: white;\n}\n.paginationButton > :nth-child(3) {\n  padding: 0px 12px;\n  height: 32px;\n  border: none;\n  border-radius: 2px;\n  margin-right: 3px;\n  font-size: 14px;\n  color: #333;\n  font-weight: 600;\n  background-color: #bbf8c5;\n  display: flex;\n  align-items: center;\n}\n.paginationButton button:nth-child(4) {\n  padding: 0px 12px;\n  height: 32px;\n  border: 1px solid var(--Primary_color);\n  border-radius: 2px;\n  margin-right: 3px;\n  border: none;\n  color: #fff;\n  font-size: 14px;\n  background-color: var(--Primary_color);\n}\n\n.paginationButton button:disabled {\n  background-color: #93cfa3;\n}\n\n.backButton {\n  background-color: transparent;\n  border: none;\n}\n.backButton > img {\n  width: 30px;\n  height: 30px;\n}\n\n.paginationButton {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.page-input {\n  width: 100px;\n  padding: 5px;\n  text-align: center;\n}\n\n.go-button {\n  padding: 5px 10px;\n  cursor: pointer;\n}\n\n.input-container {\n  position: relative;\n  display: inline-block;\n}\n\n.page-input {\n  width: 100px;\n  padding: 8px 28px 8px 10px; /* right padding for icon */\n  box-sizing: border-box;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  font-size: 14px;\n}\n\n.input-icon {\n  position: absolute;\n  top: 50%;\n  right: 10px;\n  transform: translateY(-50%);\n  color: #999;\n  font-size: 14px;\n  pointer-events: none;\n  line-height: 1;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
